import React from "react";

import { StyledTextArea, StyledTextAreaProps } from "./styled";

type TextInputProps = {
  inputValue?: string;
  placeholder?: string;
  disabled?: boolean;
  onChangeHandler?: React.ChangeEventHandler<HTMLTextAreaElement>;
  autoFocus?: boolean;
  maxlength?: string;
} & StyledTextAreaProps;

export const TextArea: React.FC<TextInputProps> = ({
  inputValue,
  onChangeHandler,
  placeholder,
  disabled = false,
  autoFocus,
  maxlength,
  ...styles
}) => {
  return (
    <StyledTextArea
      value={inputValue}
      onChange={onChangeHandler}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      maxLength={maxlength ? Number(maxlength) : -1}
      {...styles}
    />
  );
};
